import { render } from "./topicInfo.vue?vue&type=template&id=8f136540&scoped=true"
import script from "./topicInfo.vue?vue&type=script&lang=js"
export * from "./topicInfo.vue?vue&type=script&lang=js"

import "./topicInfo.vue?vue&type=style&index=0&id=8f136540&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f136540"]])

export default __exports__